import type { ComponentType, SVGProps } from 'react';

interface SiPortalEmBreveProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  titulo?: string;
  descricao: string;
}

/** Espaço reservado das abas/seções que entram nas próximas fases (ver discovery/SI/03-PORTAL-SI.md). */
export function SiPortalEmBreve({ icon: Icon, titulo = 'Em breve', descricao }: SiPortalEmBreveProps) {
  return (
    <div className="flex flex-col items-center rounded-2xl border border-dashed border-primary-200 bg-white px-6 py-12 text-center">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </span>
      <p className="mt-4 font-montserrat text-sm font-semibold text-raro-gray-900">{titulo}</p>
      <p className="mt-1 max-w-md text-sm text-raro-gray-500">{descricao}</p>
    </div>
  );
}
